var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('list-items-view',{attrs:{"title":"Заявки на возврат","headers":_vm.headers,"items":_vm.result.data,"loading":_vm.inProcess,"pagination":{
             page: _vm.result.page,
             limit: _vm.result.limit,
             total: _vm.result.totalItems
          }},on:{"page-changed":_vm.fetch,"limit-changed":_vm.limitChanged},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
          var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("datetime")(item.createdAt))+" ")]}},{key:"item.willBeRefundedOn",fn:function(ref){
          var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("datetime")(item.willBeRefundedOn))+" ")]}},{key:"item.amountRefunded",fn:function(ref){
          var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.amountRefunded / 100))+" ")]}},{key:"item.status",fn:function(ref){
          var item = ref.item;
return [_c('v-chip',{attrs:{"small":"","dark":"","label":"","color":_vm.statusLabels[item.status].color}},[_vm._v(" "+_vm._s(_vm.statusLabels[item.status].label)+" ")])]}},{key:"item.action",fn:function(ref){
          var item = ref.item;
return [_c('v-btn',{staticClass:"mx-3",attrs:{"icon":"","to":{ name: 'refundMoneyRequest', params: { id: item.id } }}},[_c('v-icon',{attrs:{"small":"","label":"Открыть"}},[_vm._v("fa-eye")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }